import './App.css';
import ImagingTest from './pages/imaging/ImagingTest';




function App() {
  return (
    <ImagingTest />
  );
}

export default App;
